// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

// Default Content
export const StyledGrid = styled(Content)`
  margin: 14px 0 24px 6px;
  min-height: 280px;
  
 .sub-card { 
     width: 33.33%;
    text-align: center;
    font-size: 12px;
    padding-left: 0px;
    padding-right: 0px;
    
  a { 
    text-overflow: ellipse;
    white-space: no-wrap;
  }
 }
`

export const StyledCategoryDiv = styled.div`
  height: 100%;
  a { 
    color: inherit;
  }
  .ant-card { 
    height: 100%;
  }
  .ant-card-body p { 
    padding: 5px 10px;
    height: 100px;
  }
`

export const StyledSection = styled.section`
  width: 100%;
`

export const StyledCard = styled(Card)`
  height: 100%;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/view-dashboard/style.js